import type { ChangelogEntry } from "../types";

/**
 * VIB-2788. Chunk-feil etter en deploy ble svelget og endte som en
 * uforståelig teknisk melding i stedet for en reload.
 *
 * Ingen rollekrav: feilen kunne treffe hvem som helst, hvor som helst i
 * systemet, siden den gjaldt alle deler som lastes ved behov.
 */
export const CHUNK_FEIL_2026_10: ChangelogEntry = {
  id: "2026-10-06-chunk-feil",
  date: "2026-10-06",
  title: "Færre rare feilmeldinger etter en oppdatering",
  summary:
    "Når Revehiet oppdateres mens du har det åpent, laster siden seg selv om i stedet for å gi en teknisk feilmelding.",
  sections: [
    {
      heading: "Overalt i Revehiet",
      items: [
        {
          title: "«Cannot destructure property …» er borte",
          kind: "rettet",
          body: "Blir Revehiet oppdatert mens du har en fane åpen, må deler av systemet hentes på nytt. Gikk det galt, kunne du få en teknisk melding som ikke sa noe om hva som skjedde. Erik så den da han lastet opp et tilbud. Nå laster siden seg selv om, og hjelper ikke det, får du beskjed om å laste siden på nytt i klartekst.",
        },
        {
          title: "Siden laster seg om igjen ved en senere oppdatering",
          kind: "rettet",
          body: "Har du en fane åpen hele dagen, kommer det gjerne flere oppdateringer. Før ble bare den første håndtert, og resten av dagen måtte du laste siden manuelt. Nå håndteres de også senere på dagen.",
        },
      ],
    },
  ],
};
